export default theme => ({
  // eslint-disable-line
  relatedArticles: {
    backgroundColor: "var(--page-accent)",
    paddingTop: 65,
    "& > .MuiTypography-root": {
      textTransform: "uppercase",
      marginBottom: 65,
      color: "var(--uow-royal-blue) !important",
    },
    "& .slick-slider": {
      paddingBottom: 70,
      margin: 0,
      maxWidth: '100%',
      width: 572,
      "& .slick-list": {
        overflow: "visible",
        "& .slick-track": {
          "& .slick-slide": {
            paddingRight: 24,
          },
        },
      },
      "& .slick-dots": {
        bottom: 0,
        left: 0,
        transformOrigin: "0 50%",
        transform: "scaleX(1.25)",
        width: "auto",
        "& li": {
          fontSize: 0,
          lineHeight: 0,
          width: "auto",
          height: "auto",
          padding: 0,
          "& button": {
            width: 10,
            height: 10,
            border: "2px solid var(--uow-royal-blue)",
            fontSize: 0,
            lineHeight: 0,
            padding: 0,
            backgroundColor: "transparent",
            color: 'var(--uow-royal-blue)',
            transition: "background-color .3s ease-in-out",
            transform: "rotate(45deg)",
            "&:before": {
              display: "none",
            },
            '&:focus': {
              outline: '1px solid var(--uow-white)',
            }
          },
          "&.slick-active": {
            "& button": {
              backgroundColor: "var(--uow-royal-blue)",
              color: 'var(--uow-white)',
            },
          },
        },
      },
    },
  },
})
